<div
  [innerHTML]="label">
</div>